
import React from 'react';
import DisplaySettings from '../components/common/TabPanel/DisplaySettings';
import InfoConsumable from '../components/common/TabPanel/InfoConsumable';
import Analysis from '../components/common/TabPanel/Analysis';
import Actions from '../components/common/TabPanel/Actions';
import DefaultTab from '../components/common/TabPanel/DefaultTab';
import AnalysisResult from '../components/common/TabPanel/AnalysisResult';


export const GenComponentName = (label, content) => {

    // Define your components here
    const components = {
        'DisplaySettings': DisplaySettings,
        'InfoConsumable': InfoConsumable,
        'Analysis': Analysis,
        'AnalysisResults': AnalysisResult,
        'Actions': Actions,
        // Add more components as needed
    };

    // Convert label to a format matching the keys in the components object
    const componentName = label.replace(/[\s/]+/g, '');
    // Get the component function from the components object
    const Component = components[componentName];
    // Return the component, or a default one if not found
    return Component ? <Component content={content} /> : <DefaultTab content={content} />;
};